import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleHalfLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 1.875C14.4873 1.875 18.125 5.51269 18.125 10C18.125 14.4873 14.4873 18.125 10 18.125C5.51269 18.125 1.875 14.4873 1.875 10C1.875 5.51269 5.51269 1.875 10 1.875ZM10 3.125C6.20304 3.125 3.125 6.20304 3.125 10C3.125 13.797 6.20304 16.875 10 16.875C13.797 16.875 16.875 13.797 16.875 10C16.875 6.20304 13.797 3.125 10 3.125ZM10 4.79167C12.8765 4.79167 15.2083 7.12352 15.2083 10C15.2083 12.8765 12.8765 15.2083 10 15.2083V4.79167Z",
		fill: "#FFA63D"
	})
});
export default SvgCircleHalfLine;
